var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"oval_img_item d-flex"},[_c('img',{staticClass:"flex-shrink-0",attrs:{"src":_vm.img}}),_c('p',{staticClass:"i_body_l"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }